export function renderPropertyCell(property) {
  const isActive = property.active;
  const inactiveClass = isActive ? "" : "table-link--inactive";

  const status = property.status.toLowerCase().replace(" ", "-");
  const classes = `status status--${status} table-link ${inactiveClass}`;

  let title = `Status: ${property.status}`;
  if (!isActive) {
    title += "\nState: Inactive";
  }

  return `<a title='${title}' class='${classes}' href='/live/properties/${property._id}' target='_blank'>${property.label}</a>`;
}

export function renderDwellingCell(dwelling) {
  const isActive = dwelling.active;
  const inactiveClass = isActive ? "" : "table-link--inactive";

  let title = "";
  let classes = `table-link ${inactiveClass}`;

  if (!isActive) {
    title = "State: Inactive";
  }

  return `<a title='${title}' class='${classes}' href='/live/dwellings/${dwelling._id}' target='_blank'>${dwelling.label}</a>`;
}
